export default function partnerReducer(partner, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "defaultPbx":
      return {
        ...partner,
        [action.type]: action.value === null ? action.value : partner.pbxes.find((pbx) => pbx.id === action.value),
      };
    case "supportEmail":
    case "salesEmail":
      return { ...partner, [action.type]: action.value === "" ? null : action.value };

    default:
      return { ...partner, [action.type]: action.value };
  }
}
